// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import axios from 'axios'
import { UserRpps } from '@saas/interfaces/core'
import { User } from '@saas/interfaces/graphql'
import { capitalizeFirstLetter } from './stringUtils'

/**
 * Find physician by rpps
 * @param {string} rpps
 */
export const searchPhysician = async (rpps: string | number) => {
    try {
        const queryParams = {
            identifiantpp: rpps,
        }
        const response = await axios.get(`${window._env_.REACT_APP_HDS_HOST}/physiciansById`, {
            params: queryParams,
        })
        if (response.status === 200 && response.data.length > 0) {
            return response.data
        }
    } catch (error) {
        console.log(error)
    }

    return false
}

/**
 * Find physician
 * @param {string} rpps
 */
export const searchPhysicians = async (
    search: string,
    codeprofession?: string,
): Promise<{ physicians: UserRpps[]; count: number }> => {
    try {
        const response = await axios.get<{ physicians: UserRpps[]; count: number }>(
            `${window._env_.REACT_APP_HDS_HOST}/physicians?search=${search}&withCount=true&limit=10&categorieprofessionnelle=C${
                codeprofession ? '&codeprofession=10' : ''
            }`,{
                headers: {
                    'X-Session-Token': localStorage.getItem('sessionToken'),
                },
            }
        )
        if (response.status === 200 && response.data.physicians.length > 0) {
            return {
                count: response.data.count,
                physicians: response.data.physicians.map((physician) => ({
                    ...physician,
                    firstName: capitalizeFirstLetter(physician.prenomdexercice),
                    lastName: physician.nomdexercice.toUpperCase(),
                })),
            }
        }
    } catch (error) {
        console.error(error)
    }
    return { physicians: [], count: 0 }
}

export const getTitle = (user: User) => {
    if (user?.prefix) {
        return ToktokdocLib.Utils.toSuperscript(user.prefix)
    }
    if (user?.civility) {
        if (user.civility === 'M') {
            return `${user.civility}.`
        }
        const rest = user.civility.slice(1).toLowerCase()
        return `${user.civility[0].toUpperCase()}${ToktokdocLib.Utils.toSuperscript(rest)}`
    }
    return ''
}
